const stackerConstants = {
  ADD_PENDING_STACK: "ADD_PRODUCT_TO_STACK",
  ADD_ADDED_STACK: "ADD_ADDED_STACK",
  PAGINATION_RESET: "PAGINATION_RESET",
  PREVIEW_SELECTION: "PREVIEW_SELECTION",
  PRODUCT_ITEM_LOADED: "PRODUCT_ITEM_LOADED",
  PRODUCT_LIST_LOADED: "PRODUCT_LIST_LOADED",
  PRODUCTS_NEXT_PAGE: "PRODUCT_LIST_LOADED",
  PRODUCT_LIST_EXPANDED: "PRODUCT_LIST_EXPANDED",
  REFINER_ADD: "REFINER_ADD",
  REFINER_MAP: "REFINER_MAP",
  REFINER_METAL_CHANGE: "REFINER_METAL_CHANGE",
  REFINER_RESET: "REFINER_RESET",
  REFINER_SIZE_CHANGE: "REFINER_SIZE_CHANGE",
  REFINER_SWATCH_CHANGE: "REFINER_SWATCH_CHANGE",
  REVIEW_SELECTION: "REVIEW_SELECTION",
  SET_ADDED_STACK: "SET_ADDED_STACK",
  SET_CONFIG: "SET_CONFIG",
  SET_LOAD_STATUS: "SET_LOAD_STATUS",
  SET_PENDING_STACK: "SET_PENDING_STACK",
  SET_STACKER_READY: "SET_STACKER_READY",
  SET_FILTER_OPEN: "SET_FILTER_OPEN",
  SHOW_PRODUCT_INFO: "SHOW_PRODUCT_INFO",
  STACKER_LOAD_START: "STACKER_LOAD_START",
  STACKER_LOAD_PENDING: "STACKER_LOAD_PENDING",
  STACKER_LOAD_COMPLETE: "STACKER_LOAD_COMPLETE",
  STACKER_LOAD_ERROR: "STACKER_LOAD_ERROR",
  STACKER_REARRANGE: "STACKER_REARRANGE",
  STACKER_RESET: "STACKER_RESET",
  STACKER_LOADED: "STACKER_LOADED",
  UPDATE_STACK_URL: "UPDATE_STACK_URL",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
  CLEAR_PRODUCTS: "CLEAR_PRODUCTS",
  AMULET_TUTORIAL_COOKIE: "amulet_tutorial_viewed",
  BRACELET_TUTORIAL_COOKIE: "bracelet_tutorial_viewed",
  T_CHAIN: "N16699DSS",
  T_CHAIN_VARIANT: "N16699DSSADI",
}

export default stackerConstants
